import storage from './storage'
import config from './config'
import * as tools from './tools'

export const Catch = storage
export const Conf = config
export const Tools = tools